<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Global - Detalhes Empresas</h3>
            </div>
            <div class="col-auto">
              <b-btn @click="exportar">
                <i class="fas fa-file-excel"></i>  Exportar
              </b-btn>
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>

        <filtro :find="find"></filtro>

        <div class="mt-3">
          <b-card>
              <div class="row">
                <b-col class="my-1">
                  <b-pagination
                    v-if="totalRows > 10"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </b-col>
              </div>
              <b-table show-empty emptyText="Não há itens para exibir"
              ref="table" id="my-table"
              :current-page="currentPage"
              :per-page="perPage" selectable
              :busy="loading" :items="detalhesEmpresas" sticky-header
              :fields="fields" small
              striped hover bordered>
                <div slot="table-busy" class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Carregando...</strong>
                </div>
              </b-table>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import filtro from '@/components/financeiro/Filtro';

export default {
  components: {
    filtro
  },
  computed: {
      loading() {
          return this.$store.getters.loading;
      }
  },
  data () {
    return {
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        items: [],
        fields: [
            {key:"nomeEmpresa",class:"text-center",label:"Nome Empresa"},
            {key:"totalVendido",class:"text-center",label:"Total Vendido",formatter:this.createdAtFormataMoney},
            {key:"totalFatura",class:"text-center",label:"Total fatura"},
            {key:"totalPago",class:"text-center",label:"Total Pago",formatter:this.createdAtFormataMoney},
            {key:"faturasPago",class:"text-center",label:"Faturas Pagas"},
            {key:"totalVencido",class:"text-center",label:"Total Vencido",formatter:this.createdAtFormataMoney},
            {key:"faturasVencida",class:"text-center",label:"Faturas Vencidas"},
            {key:"totalAguardando",class:"text-center",label:"Total Aguardando Pagamento",formatter:this.createdAtFormataMoney},
            {key:"faturaAguardando",class:"text-center",label:"Fatura Aguardando"},
            {key:"totalBoleto",class:"text-Center",label:"Total em Boleto",formatter:this.createdAtFormataMoney},
            {key:"totalBoletoDrAchei",class:"text-Center",label:"Total em Boleto DrAchei",formatter:this.createdAtFormataMoney},
            {key:"totalBoletoEmpresa",class:"text-Center",label:"Total em Boleto Empresa",formatter:this.createdAtFormataMoney},
            {key:"totalCartao",class:"text-center",label:"Total Cartão Crédito",formatter:this.createdAtFormataMoney},
            {key:"totalCartaoDrAchei",class:"text-center",label:"Total Cartão Crédito DrAchei",formatter:this.createdAtFormataMoney},
            {key:"totalCartaoEmpresa",class:"text-center",label:"Total Cartão Crédito Empresa",formatter:this.createdAtFormataMoney},
            {key:"totalDinheiro",class:"text-center",label:"Total em dinheiro",formatter:this.createdAtFormataMoney},
            {key:"totalDinheiroDrAchei",class:"text-center",label:"Total em dinheiro DrAchei",formatter:this.createdAtFormataMoney},
            {key:"totalDinheiroEmpresa",class:"text-center",label:"Total em dinheiro Empresa",formatter:this.createdAtFormataMoney},
            {key:"totalrepasseEmpresa",class:"text-center",label:"Total repasse Empresa",formatter:this.createdAtFormataMoney},
            {key:"totalComDrachei",class:"text-center",label:"Total com a Dr.Achei",formatter:this.createdAtFormataMoney},
            {key:"repasseEmpresaFinal",class:"text-center", label:"Repasse Final para a empresa",formatter:this.createdAtFormataMoney},
            {key:"repasseDrAchei",class:"text-center",label:"Dr.achei com Imposto",formatter:this.createdAtFormataMoney},
            {key:"imposto",class:"text-center",label:"Imposto",formatter:this.createdAtFormataMoney}
        ],
    }
  },
  methods: {
    voltar() {
      window.history.back();
    },
    async find() {
      this.$store.dispatch("setLoadingTable", true);
      this.$root.$emit('bv::refresh::table', 'my-table')
      this.$store.dispatch("setLoadingTable", false);
    },
    createdAtFormatter(value){
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
      return ''
    },
    createdAtFormataMoney(value){
        if (!value) return 0;
        return this.$options.filters.money(value);
    },
    async detalhesEmpresas(){
        try {
            this.$store.dispatch("setLoading",true);

            return this.$store.dispatch('findDetalhesEmpresa')
                    .then(response => response.data);
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
            alert(e.message);
        } finally {
            this.$store.dispatch("setLoading",false);
        }
    },
    async exportar() {
      this.$store.dispatch("setLoading", true);
      await this.$store.dispatch('findDetalheEmpresaExcel');
      this.$store.dispatch("setLoading", false);
    }

  }

}
</script>
<style scoped>
.b-table-sticky-header {
  overflow-y: auto;
  max-height: none;
}
</style>
